/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  requestEmbeddedSignupAccess(useCase) {
    return axios.post(`${this.baseUrl()}/whatsapp/access_request`, {
      use_case: useCase,
    });
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }

  previewManualSetup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/manual/preview`, params);
  }

  connectManualSetup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/manual/connect`, params);
  }

  getManualWebhookStatus(inboxId) {
    return axios.get(
      `${this.baseUrl()}/whatsapp/manual/${inboxId}/webhook_status`
    );
  }

  setupManualWebhook(inboxId) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/manual/${inboxId}/setup_webhook`
    );
  }

  getEvolutionGoLimits(provider = 'evolution_go') {
    return axios.get(`${this.baseUrl()}/whatsapp/evolution_go/limits`, {
      params: { provider },
    });
  }

  getEvolutionGoStatus(inboxId) {
    return axios.get(
      `${this.baseUrl()}/whatsapp/evolution_go/${inboxId}/status`
    );
  }

  getEvolutionGoQrCode(inboxId) {
    return axios.get(
      `${this.baseUrl()}/whatsapp/evolution_go/${inboxId}/qr_code`
    );
  }

  connectEvolutionGo(inboxId) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/evolution_go/${inboxId}/connect`
    );
  }

  pairEvolutionGo(inboxId, phone) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/evolution_go/${inboxId}/pair`,
      { phone }
    );
  }

  disconnectEvolutionGo(inboxId) {
    return axios.post(
      `${this.baseUrl()}/whatsapp/evolution_go/${inboxId}/disconnect`
    );
  }

  updateEvolutionGoSettings(inboxId, advancedSettings) {
    return axios.put(
      `${this.baseUrl()}/whatsapp/evolution_go/${inboxId}/settings`,
      { advanced_settings: advancedSettings }
    );
  }
}

export default new WhatsappChannel();
